import moment from 'moment';

import { DATE_FORMAT } from '../config';

export default function fromNow(val: string) {
  // eslint-disable-next-line import/no-named-as-default-member
  return moment.utc(val, DATE_FORMAT).local().fromNow();
}
